const generateErrorMessage = (errorCode: string): string => {
  const errorCodeNumber = parseInt(errorCode, 10)

  if (errorCodeNumber >= 1 && errorCodeNumber <= 27) {
    return errorCode
  } else {
    return '0000'
  }
}

export default generateErrorMessage
